import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Sizes, MessagePropType } from '@ratehub/base-ui';

import ProductName from './ProductName';
import PFAWinnerPill from './PFAWinnerPill';


function DepositsProductName({ name, provider, onClick, isPFAWinner, isNameOnNewLine }) {
    return (
        <ProductName
            image={{
                url: provider.logo,
                alt: (
                    <FormattedMessage
                        id="web-components.deposits.logo-alt"
                        defaultMessage="{providerName} logo"
                        values={{ providerName: provider.name }}
                    />
                ),
                width: Sizes.SPACING.TWO_AND_A_HALF,
            }}
            productName={name || provider.name}
            onClick={onClick}

            data-test-name="deposits-product-name"
            isNameOnNewLine={isNameOnNewLine}
        >
            <If condition={isPFAWinner}>
                <PFAWinnerPill />
            </If>
        </ProductName>
    );
}

DepositsProductName.propTypes = {
    name: MessagePropType,
    provider: PropTypes.shape({
        name: PropTypes.string.isRequired,
        logo: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func,
    isPFAWinner: PropTypes.bool,
    isNameOnNewLine: PropTypes.bool,
};


export default DepositsProductName;
